;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();export const fragment = /* GraphQL */ `
    fragment CardProductFragment on Product {
        award {
            json
        }
        category {
            slug
            attributes
        }
        textColor
        color
        displayName
        eyebrow
        icon
        slug
        sys {
            id
        }
        sizes3Collection {
            items {
                size
                sku2
            }
        }
        image {
            ...Asset
        }
    }
`;
